$('.collapsible .collapsible-label').click(function(){
  $(this).find('i').toggleClass('fa-plus-square fa-minus-square')
})
